import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  data: {}, 
  loading: false,
  error: null 
};

/* ================== THUNKS ================== */

export const verifyPaymentCallback = createAsyncThunk(
  'payment/verify',
  async ({ transactionId, userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/mobile/payment/verify?transactionId=${transactionId}&userId=${userId}`);
      return { 
        data: response.data || [],
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


/* ================== SLICE ================== */

const paymentCallbackSlice = createSlice({
  name: 'payment-callback',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyPaymentCallback.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyPaymentCallback.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.data = data;
      })
      .addCase(verifyPaymentCallback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  }
});

export default paymentCallbackSlice.reducer;